export const signupStates = {
  signup: 'signup',
  signupInvitation: 'signupInvitation',
  resendInvitation: 'resendInvitation',
  resendInvitationSuccess: 'resendInvitationSuccess',
  forgottenPassword: 'forgottenPassword',
  resetPassword: 'resetPassword',
} as const;
